import { createRouter, createWebHistory } from 'vue-router'
import Home from './pages/Home.vue'
import HrDashboard from './pages/hr/HrDashboard.vue'
import ManPower from './pages/hr/ManPower.vue'
import Onboarding from './pages/hr/Onboarding.vue'
import Contract from './pages/hr/Contract.vue'
import EmploymentContract from './pages/hr/EmploymentContract.vue'
import ContractRenewal from './pages/hr/ContractRenewal.vue'
import PromotionForm from './pages/hr/PromotionForm.vue'
import TerminationForm from './pages/hr/TerminationForm.vue'
import StaffDirectory from './pages/hr/StaffDirectory.vue'
import Attendance from './pages/hr/Attendance.vue'
import Appraisals from './pages/hr/Appraisals.vue'
import LeaveManagement from './pages/hr/LeaveManagement.vue'
import Departments from './pages/hr/Departments.vue'
import Positions from './pages/hr/Positions.vue'
import ContractTypes from './pages/hr/ContractTypes.vue'
import LeaveTypes from './pages/hr/LeaveTypes.vue'
import AttendanceStatus from './pages/hr/AttendanceStatus.vue'
import ContractStatus from './pages/hr/ContractStatus.vue'
import EmployeeActions from './pages/hr/EmployeeActions.vue'
import Sections from './pages/hr/Sections.vue'
import ProcessTypes from './pages/hr/ProcessTypes.vue'
import Class from './pages/hr/Class.vue'
import Users from './pages/admin/Users.vue'
import Subject from './pages/hr/Subject.vue'
import StaffDetails from './pages/hr/StaffDetails.vue'
import EditEmployeeProfile from './pages/hr/EditEmployeeProfile.vue'
import Agency from './pages/hr/Agency.vue'
import CheckList from './pages/hr/CheckList.vue'
import Allowances from './pages/hr/Allowances.vue'
import Calendar from './pages/acd/Calendar.vue'
import Terms from './pages/acd/Terms.vue'
import AcademicYears from './pages/acd/AcademicYears.vue'
import HolidayType from './pages/acd/HolidayType.vue'
import CalendarView from './pages/acd/Calendar.vue'
import WorkingHours from './pages/hr/WorkingHours.vue'
import InterviewQuestions from './pages/hr/InterviewQuestions.vue'
import FirstInterview from './pages/hr/FirstInterview.vue'
import InterviewEvaluation from './pages/hr/InterviewEvaluation.vue'
import UserPermissions from './pages/hr/UserPermissions.vue'
import Modules from './pages/hr/Modules.vue'
import Permissions from './pages/hr/Permissions.vue'
import AuditLogs from './pages/hr/AuditLogs.vue'
import Dashboard from './pages/emp/Dashboard.vue'
import OnboardingForm from './pages/emp/OnboardingForm.vue'
import TeachDashboard from './pages/acd/TeachDashboard.vue'
import TeachOnboardingForm from './pages/acd/TeachOnboardingForm.vue'
import AcademicsDashboard from './pages/acd/AcademicsDashboard.vue'
import AdminDashboard from './pages/admin/AdminDashboard.vue'
import HrUsers from './pages/hr/HrUsers.vue'
import MainPage from './pages/admin/MainPage.vue'
import ResetFirstPassword from './pages/hr/ResetFirstPassword.vue'
import ItDashboard from './pages/it/ItDashboard.vue'
import EmployeeAccounts from './pages/it/EmployeeAccounts.vue'
import ComDashboard from './pages/com/ComDashboard.vue'
import ComUsers from './pages/com/ComUsers.vue'
import StaffPictures from './pages/com/StaffPictures.vue'
import PersonalInformation from './pages/hr/PersonalInformation.vue'
import AdministrationDashboard from './pages/administration/AdministrationDashboard.vue'
import Leaves from './pages/hr/Leaves.vue'



const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/admin-dashboard',
            name: '/admin-dashboard',
            component: AdminDashboard,
            meta: { requiresAuth: true }

        },
        {
            path:'/test',
            name: '/test',
            component: TeachOnboardingForm
        },
        {
            path: '/main-page',
            name: '/main-page',
            component: MainPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/hrdashboard',
            name: 'hrdashboard',
            component: HrDashboard,
            meta: { requiresAuth: true }
        },
        {
            path:'/users',
            name:'/users',
            component: Users,
            meta: { requiresAuth: true }

        },
        {
            path:'/reset-first-password',
            name: '/reset-first-password',
            component:ResetFirstPassword,
        },
        {
            path: '/manpower',
            name: 'manpower',
            component: ManPower,
            meta: { requiresAuth: true }
        },
        {
            path: '/onboarding',
            name: 'onboarding',
            component: Onboarding,
            meta: { requiresAuth: true }
        },
        {
            path: '/academics/onboarding',
            name: 'academics-onboarding',
            component: Onboarding,
            meta: { requiresAuth: true }
        },
        {
            path: '/contracts',
            name: 'contract',
            component: Contract,
            meta: { requiresAuth: true }
        },
        {
            path: '/employmentcontract',
            name: 'employmentcontract',
            component: EmploymentContract,
            meta: { requiresAuth: true }
        },
        {
            path: '/contractrenewal',
            name: 'contractrenewal',
            component: ContractRenewal,
            meta: { requiresAuth: true }
        },
        {
            path: '/promotionform',
            name: 'promotionform',
            component: PromotionForm,
            meta: { requiresAuth: true }
        },
        {
            path: '/terminationform',
            name: 'terminationform',
            component: TerminationForm,
            meta: { requiresAuth: true }
        },
        {
            path: '/staff',
            name: 'staff',
            component: StaffDirectory,
            meta: { requiresAuth: true }
        },
        {
            path: '/attendance',
            name: 'attendance',
            component: Attendance,
            meta: { requiresAuth: true }
        },
        {
            path: '/appraisals',
            name: 'appraisals',
            component: Appraisals,
            meta: { requiresAuth: true }
        },
        {
            path: '/leave',
            name: 'leavemanagement',
            component: LeaveManagement,
            meta: { requiresAuth: true }
        },
        {
            path: '/departments',
            name: 'departments',
            component: Departments
        },
        {
            path: '/positions',
            name: 'positions',
            component: Positions
        },
        {
            path: '/contract-types',
            name: 'contracttypes',
            component: ContractTypes
        },
        {
            path: '/leave-types',
            name: 'leavetypes',
            component: LeaveTypes
        },
        {
            path: '/attendance-status',
            name: 'attendancestatus',
            component: AttendanceStatus
        },
        {
            path: '/contract-status',
            name: 'contractstatus',
            component: ContractStatus
        },
        {
            path:'/employee-actions',
            name: 'employeeactions',
            component: EmployeeActions
        },
        {
            path: '/sections',
            name: 'sections',
            component: Sections
        },
        {
            path:'/classes',
            name: 'classes',
            component: Class
        },
        {
            path: '/hr-users',
            name: 'hr-users',
            component: HrUsers,
            meta: { requiresAuth: true }
        },
        {
            path:'/subjects',
            come: 'subjects',
            component: Subject
        },
        {
            path: '/staff/:id',
            name: 'staffdetails',
            component: StaffDetails,
            meta: { requiresAuth: true }
        },
        {
            path:'/agency',
            name: 'agency',
            component: Agency
        },
        {
          path: '/staff/:id/edit',
          name: 'EditEmployeeProfile',
          component: EditEmployeeProfile,
          meta: { requiresAuth: true }
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar
        },
        {
            path: '/terms',
            name: 'terms',
            component: Terms
        },
        {
            path: '/academic-years',
            name: 'academicyears',
            component: AcademicYears
        },
        {
            path: '/holiday-types',
            name: 'holidaytypes',
            component: HolidayType
        },
        {
          path: '/calendar/view',
          name: 'CalendarView',
          component: CalendarView
        },
        {
            path: '/allowances',
            name: 'allowances',
            component: Allowances,
            meta: { requiresAuth: true }
        },
        {
            path: '/process-types',
            name: 'processtypes',
            component: ProcessTypes,
            meta: { requiresAuth: true }
        },
        {
            path: '/checklist',
            name: 'checklist',
            component: CheckList,
            meta: { requiresAuth: true }
        },
        {
            path: '/working-hours',
            name: 'workinghours',
            component: WorkingHours
        },
        {
            path: '/interview-questions',
            name: 'interviewquestions',
            component: InterviewQuestions
        },
        {
             path: '/interview/:id',      
            name: 'Interview',
            component: FirstInterview,
            props: true,
            meta: { requiresAuth: true }
        },
        {
            path: '/interview-evaluation/',
            name: 'interviewevaluation',
            component: InterviewEvaluation,
            props: true,
            meta: { requiresAuth: true }
        },
        {
            path: '/permissions',
            name: '/permissions',
            component: Permissions,
            meta: { requiresAuth: true }
        },
        {
            path: '/modules',
            name: '/modules',
            component: Modules,
            meta: { requiresAuth: true }
        },
        {
            path: '/user-permission',
            name: '/user-permission',
            component: UserPermissions,
            meta: { requiresAuth: true }
        },
        {
            path: '/audit-logs',
            name: '/audit-logs',
            component: AuditLogs,
            meta: { requiresAuth: true }
        },
        {
            path: '/emp-dashboard',
            name: '/emp-dashboard',
            component: Dashboard,
            meta: { requiresAuth: true }
        },
        {
            path: '/onboarding-form',
            name: '/onboarding-form',
            component: OnboardingForm,
            meta: { requiresAuth: true }
        },
           {
            path: '/teachers-dashboard',
            name: '/teachers-dashboard',
            component: TeachDashboard,
            meta: { requiresAuth: true }
        },
        {
            path: '/teachers-onboarding-form',
            name: '/teachers-onboarding-form',
            component: TeachOnboardingForm,
            meta: { requiresAuth: true }
        },
        {
            path:'/academics-dashboard',
            name: '/academics-dashboard',
            component: AcademicsDashboard,
            meta: { requiresAuth: true }
        },
        {
            path: '/it-dashboard',
            name:'/it-dashboard',
            component: ItDashboard,
            meta: { requiresAuth: true }
        },
        {
            path:'/employee-accounts',
            name:'/employee-accounts',
            component: EmployeeAccounts
        },
            {
            path: '/it/onboarding',
            name: 'it-onboarding',
            component: Onboarding,
            meta: { requiresAuth: true }
            
        },
        {
            path:'/com-dashboard',
            name: 'com-dashboard',
            component: ComDashboard,
            meta: { requiresAuth: true }
        },
        {
            path: '/com/onboarding',
            name: 'com-onboarding',
            component: Onboarding,
            meta: { requiresAuth: true }
            
        },
        {
            path: '/com-users',
            name: 'com-users',
            component: ComUsers,
            meta: { requiresAuth: true }
        },
        {
            path: '/staff-pictures',
            name: 'staff-pictures',
            component: StaffPictures,
            meta: { requiresAuth: true }
        },
        {
            path: '/personal-info',
            name: '/personal-info',
            component: PersonalInformation,
            meta: { requiresAuth: true }
        },
               {
            path: '/academics/personal-info',
            name: 'academics-personal-info',
            component: PersonalInformation,
            meta: { requiresAuth: true }
        },
              {
            path: '/it/personal-info',
            name: 'it-personal-info',
            component: PersonalInformation,
            meta: { requiresAuth: true }
        },
                      {
            path: '/com/personal-info',
            name: 'com-personal-info',
            component: PersonalInformation,
            meta: { requiresAuth: true }
        },
        {
            path: '/administration/personal-info',
            name: 'administration-personal-info',
            component: PersonalInformation,
            meta: { requiresAuth: true }
        },
                {
            path: '/administration/onboarding',
            name: 'administration-onboarding',
            component: Onboarding,
            meta: { requiresAuth: true }
            
        },
          {
            path:'/administration-dashboard',
            name: 'administration-dashboard',
            component: AdministrationDashboard,
            meta: { requiresAuth: true }
        },
                {
            path: '/academics/leaves',
            name: 'academics-leaves',
            component: Leaves,
            meta: { requiresAuth: true }
        },
                {
            path: '/com/leaves',
            name: 'com-leaves',
            component: Leaves,
            meta: { requiresAuth: true }
        },
                        {
            path: '/it/leaves',
            name: 'it-leaves',
            component: Leaves,
            meta: { requiresAuth: true }
        },
                        {
            path: '/administration/leaves',
            name: 'administration-leaves',
            component: Leaves,
            meta: { requiresAuth: true }
        },

        


    ]
});
router.beforeEach((to, from, next) => {
  const userStr = localStorage.getItem('user');
  const isLoggedIn = !!userStr;
  const user = userStr ? JSON.parse(userStr) : null;

  // 1. Handle Authentication First
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/');
    return;
  }

  // 2. Force Password Reset Logic (for non-admin users)
  if (isLoggedIn && user) {
    const isAdmin = user.role && 
                    (user.role.toUpperCase() === 'ADMIN' || 
                     user.role.toUpperCase() === 'ADMINISTRATOR');

    const mustChangePassword = user.must_change_password === true || 
                               user.must_change_password === 1;

    // If user must change password and is NOT an admin
    // AND trying to access any other page except the reset page
    if (mustChangePassword && !isAdmin && to.path !== '/reset-first-password') {
      next('/reset-first-password');
      return;
    }

    // Prevent accessing reset page if not needed
    if (to.path === '/reset-first-password' && (!mustChangePassword || isAdmin)) {
      next('/');   
      return;
    }
  }

  next();
});


export default router